import React, {Component} from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, Nav} from 'reactstrap';
import PropTypes from 'prop-types';

import {AppHeaderDropdown, AppSidebarToggler} from '@coreui/react';
import {Button,Icon} from 'semantic-ui-react'
import './Style.css'
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import visitortag_logo from '../../assets/img/logos/visitor_logo.png';
import parktag_logo from '../../assets/img/logos/parktag_logo.png';
import tag_logo from  '../../assets/img/logos/tag_logo.svg';
import md_logo from  '../../assets/img/logos/md-logo.png';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class SuperHeader extends Component {
  state = {
    select_tag:1,
    park_service: false,
    visitor_service: false
  };

  checkSystem(type) {

    if (type === 2)
      this.props.history.push('/super/visitorTag/dashboard');
    if (type === 1)
      this.props.history.push('/super/dashboard');
  }

  changeSystem = (type) => {
    this.checkSystem(type);
    this.props.systemChangeHandler(type);
  };

  componentDidMount(){
    let services = this.props.usr_obj.services;
    this.setState({
      park_service: true,
      visitor_service: true
    })
    if(services.length !== 0){
      services.map((service,index)=>{
        if(service.serviceId === 1){
          this.setState({
            park_service: true
          })
        }
        if(service.serviceId === 2){
          this.setState({
            visitor_service: true
          })
        }
      });
    }
  }

  render() {
    // eslint-disable-next-line
    const {children, ...attributes} = this.props;

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile/>

        <h1 className={"logo-text"}>
          <img src={md_logo} alt={"."} className={"logo-main"}/>
        </h1>
        {/*<AppSidebarToggler className="d-md-down-none" display="lg"/>*/}

        <Button animated className={this.props.system_changer === 1 ? "select-btn" : "unselect-btn"} onClick={()=>this.changeSystem(1)}>
          <Button.Content visible>
            Admin
          </Button.Content>
          <Button.Content hidden>
            Admin
            <Icon name='arrow down' />
          </Button.Content>
        </Button>

        {
          this.state.visitor_service ?
            <Button animated className={this.props.system_changer === 2 ? "select-btn" : "unselect-btn"} onClick={()=>this.changeSystem(2)}>
              <Button.Content visible>
                Visitor
              </Button.Content>
              <Button.Content hidden>
                Visitor
                <Icon name='arrow down' />
              </Button.Content>
            </Button>:null
        }

        {
          this.state.park_service ?
            <Button animated className={this.props.system_changer === 3 ? "select-btn" : "unselect-btn"} onClick={()=>this.changeSystem(3)}>
              <Button.Content visible>
                Park
              </Button.Content>
              <Button.Content hidden>
                Park
                <Icon name='arrow down' />
              </Button.Content>
            </Button>:null
        }

        <Nav className="ml-auto" navbar>
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <span style={{
                fontSize: '16px',
                color: '#585858',
                fontWeight: '600',
                marginRight:'10px'
              }}>{this.props.usr_obj === undefined ? "Welcome admin" : "Welcome " + this.props.usr_obj.fullName}
                &nbsp;
                <i className="fa fa-caret-down"/>
              </span>
              {/*<img src={usrProPic} className="img-avatar" alt="..."/>*/}
            </DropdownToggle>
            <DropdownMenu right style={{right: 'auto'}}>
              <DropdownItem onClick={e => this.props.onLogout(e)}><i className="fa fa-lock"/> Logout</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        {/*<AppAsideToggler className="d-md-down-none" />*/}
        {/*<AppAsideToggler className="d-lg-none" mobile />*/}
      </React.Fragment>
    );
  }
}

SuperHeader.propTypes = propTypes;
SuperHeader.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  system_changer: state.systemChangeReducer.system_changer,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SuperHeader);
